import React from 'react';
import { CheckCircle, Shield, Calendar, ArrowLeft } from 'lucide-react';
import { format } from 'date-fns';
import Footer from './Footer';

const ConsentSuccessPage: React.FC = () => {
    const validUntil = new Date();
    validUntil.setFullYear(validUntil.getFullYear() + 3);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <div className="flex-1 flex items-center justify-center py-12">
                <div className="max-w-md mx-auto text-center px-4">
                <div className="bg-white rounded-lg shadow-md p-8">
                    <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-6" />

                    <h1 className="text-2xl font-bold text-gray-900 mb-4">
                        Consent Submitted Successfully
                    </h1>

                    <div className="space-y-4 text-left">
                        <div className="rounded-md p-4" style={{ backgroundColor: 'rgba(105, 190, 40, 0.1)' }}>
                            <div className="flex items-start">
                                <Shield className="w-5 h-5 mr-2 mt-0.5" style={{ color: '#69BE28' }} />
                                <div>
                                    <h3 className="font-medium" style={{ color: '#231f20' }}>D906 Consent Active</h3>
                                    <p className="text-sm mt-1" style={{ color: '#69BE28' }}>
                                        Your consent has been recorded and is now active for DVLA licence checking.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2">
                            <div className="flex items-center text-sm">
                                <Calendar className="w-4 h-4 text-gray-400 mr-2" />
                                <span className="text-gray-600">Valid until:</span>
                                <span className="font-medium text-gray-900 ml-1">
                                    {format(validUntil, 'dd/MM/yyyy')}
                                </span>
                            </div>

                            <div className="text-sm text-gray-600">
                                <strong>What happens next:</strong>
                                <ul className="mt-2 space-y-1 text-xs">
                                    <li>• Your employer can now check your licence status</li>
                                    <li>• Regular compliance checks will be performed</li>
                                    <li>• You'll be notified of any important updates</li>
                                    <li>• You can withdraw consent at any time</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-200">
                        <p className="text-xs text-gray-500">
                            This consent complies with GDPR and DVLA regulations.
                            Your data will only be used for licence checking purposes.
                        </p>
                    </div>
                </div>

                <div className="mt-6">
                    <button
                        onClick={() => window.close()}
                        className="inline-flex items-center text-sm hover:opacity-80 transition-opacity"
                        style={{ color: '#69BE28' }}
                    >
                        <ArrowLeft className="w-4 h-4 mr-1" />
                        Close this window
                    </button>
                </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ConsentSuccessPage;